import Box from '@mui/material/Box';

import {
	LegacyButton,
	LegacyButtonProps,
} from 'library/components/link/LegacyButton';

export const LegacySection = (props: LegacyButtonProps): React.JSX.Element => (
	<Box>
		<LegacyButton {...props} />
	</Box>
);
